var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-box',{attrs:{"py":"3"}},[(_vm.$route.query.page !== 'presentation')?_c('c-heading',{attrs:{"mt":"3","as":"h1","fontSize":"3xl"}},[_vm._v(" "+_vm._s(_vm.activeCompany.name)+" ")]):_vm._e(),_c(_vm.pageComponent,{tag:"component",attrs:{"activeView":_vm.activeView}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }